import { Property } from "../../../../../RadObject";
import { EvaluatorList } from "../../../SeriouslyRAD.Framework/Evaluation/EvaluatorList";
import { EvaluatorListPropertyValues, IEvaluatorList } from "../../../SeriouslyRAD.Framework/Evaluation/IEvaluatorList";
import { NAMESPACE } from "./_Namespace";

export type AndEvaluatorPropertyValues =
    EvaluatorListPropertyValues
    & {
    };

export type AndEvaluatorProperties = {
    [name in keyof AndEvaluatorPropertyValues]: Property<AndEvaluatorPropertyValues[name]>
};

export interface IAndEvaluator extends IEvaluatorList, AndEvaluatorProperties
{
}

export class AndEvaluator extends EvaluatorList<AndEvaluatorPropertyValues> implements IAndEvaluator
{
    public static override classNamespace = NAMESPACE + "AndEvaluator";
    public static override className = "AndEvaluator";

    // #region Overrides

    public override evaluate()
    {
        const
            evaluators = this.evaluators.get();

        let
            value = true;

        if (evaluators?.length)
        {
            for (let i = 0; i < evaluators.length; i++)
            {
                if (!evaluators[i].value.get())
                {
                    value = false;
                    break;
                }
            }
        }

        this.value.set(value);

        return value;
    }

    // #endregion
}

